import { FunctionComponent } from "react"
import { Button, Card } from "react-bootstrap"
import { useNavigate } from "react-router-dom"

interface IRolesCard {}
const RolesCard: FunctionComponent<IRolesCard> = () => {
	const navigate = useNavigate()
	return (
		<Card className="mt-4">
			<Card.Header>Roles & Passes</Card.Header>
			<Card.Body>
				<Card.Text>
					<ul>
						<li>Adjust what doors a role has access to</li>
						<li>Adjust what ammenity doors residents have access to</li>
						<li>Adjust what exterior/common doors residents have access to</li>
					</ul>
					<Button className="mt-4" onClick={() => navigate("/roles")}>
						View Roles
					</Button>
					<br />
					<Button className="mt-4" onClick={() => navigate("/passes")}>
						View Passes
					</Button>
				</Card.Text>
			</Card.Body>
		</Card>
	)
}
export default RolesCard
